import React, { Component } from 'react';
import b from 'b_';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { NewsItem } from '@interfaces/news-page';
import { formatDate } from 'client/helpers/date';
import Button from '@components/button';
import Breadcrumbs from '@components/breadcrumbs';
import Share from '@components/share';
import PageMeta from '@components/page-meta';

import NewsPageStab from './news.stub';

import './news.css';

export interface DispatchProps {
    fetchNews(slug: string): void;
}

export interface StateProps {
    data: NewsItem;
    isLoading: boolean;
}

interface State {
    displayShareBlock: boolean;
}

type Props = StateProps & DispatchProps & RouteComponentProps<{}>;

const class_ = b.with('news-page');

class NewsPage extends Component<Props, State> {
    public readonly state = {
        displayShareBlock: false
    };

    public componentDidMount() {
        const { fetchNews, match, data } = this.props;
        const slug = (match.params as any).slug;

        if (data && data.slug !== slug) {
            fetchNews(slug);
        }
    }

    public shouldComponentUpdate() {
        return true;
    }

    public openShareBlock = () => {
        this.setState({ displayShareBlock: true });
    };

    public render() {
        const { data, isLoading } = this.props;
        const breadcrumbs = [
            { text: 'News', url: '/news' },
            { text: data.title }
        ];

        if (isLoading) {
            return (<NewsPageStab />);
        }

        return (
            <div className={class_()}>
                <PageMeta
                    title={`${data.title} - News`}
                    description={data.description}
                    image={data.image || ''}
                />
                <Breadcrumbs items={breadcrumbs} hideHome />
                <div className={class_('header')}>
                    {data.image && (
                        <img
                            className={class_('image')}
                            src={data.image}
                        />
                    )}
                    <div>
                        <h1 className={class_('title')}>{data.title}</h1>
                        <div className={class_('meta')}>{formatDate(data.createdAt)}</div>
                    </div>
                </div>
                <div
                    className={`${class_('content')} wysiwyg-content`}
                    dangerouslySetInnerHTML={{ __html: data.content as string }}
                />
                {this.renderSharing()}
            </div>
        );
    }

    private renderSharing = () => {
        const { displayShareBlock } = this.state;

        return (
            <div className={class_('share')}>
                {!displayShareBlock && (
                    <Button
                        theme="action"
                        cls="button2_size_xl"
                        onClick={this.openShareBlock}
                    >
                        Share
                    </Button>
                )}
                {displayShareBlock && <Share />}
            </div>
        );
    };
}

export default withRouter(NewsPage);
